import { createClass as _createClass, classCallCheck as _classCallCheck } from '../../../../_virtual/_rollupPluginBabelHelpers.js';

/** For creating classes that cache an arbitrary late-bound value */
var CachedLateValue = /*#__PURE__*/function () {
  function CachedLateValue() {
    _classCallCheck(this, CachedLateValue);
  }

  _createClass(CachedLateValue, [{
    key: "clear",
    value: function clear() {
      this._value = undefined;
    }
  }, {
    key: "value",
    get: function get() {
      if (this._value === undefined) this._value = this.getValue();
      return this._value;
    }
  }]);

  return CachedLateValue;
}();

export { CachedLateValue };
